//获取cookie 
export let getCookie = (name) => {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    arr = document.cookie.match(reg);
    if (arr) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

//设置cookie
export let setCookie = (name, vaule, time) => {
    let expires;
    if(time !== ''){
        let d = new Date();
        d.setTime(d.getTime() + (time*24*60*60*1000));
        expires = 'expires='+d.toUTCString();
    }else{
        expires = 'expires=';
    }
    
    document.cookie = name + '=' + vaule + ';' + 'domain=.dhgate.com;path=/;' + expires;
}

//删除cookie
export let delCookie = (name) => {
    setCookie(name, '', -1);
}